module.exports = __webpack_public_path__ + "media/images/lb/384-2bc4f81e84471e902dd88c588b1d922e.svg";